import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core';
import { Project } from '../../../features/project/models/project';
import { AppMenu } from '../../models/app-menu';
import { StateService } from '@uirouter/core';

import { User } from '../../../features/users/models/user';
import { ProjectPage } from '@/app/features/project/models/project-page';
import { ProjectConfigurationBehaviorSubjectService } from '../../../features/project/services/project-configuration-behavior-subject.service';
import { Subscription, Observable } from 'rxjs';
import { ProjectConfiguration } from '@/app/features/project/models/project-configuration';
import { ProjectDataService } from '../../../features/project/services/project-data.service';

import { map } from 'rxjs/operators';
import { UserProfileService } from '../../../features/users/services/user-profile.service';

@Component({
  selector: 'app-nav-bar',
  template: require('./nav-bar.component.html'),
  styles: [require('./nav-bar.component.sass')]
})
export class NavBarComponent implements OnInit {

  activePages: ProjectPage[];
  projectId: number;

  @Input() show: boolean;
  @Input() selectedProject: Project;
  @Input() currentUser: User;
  @Output() logout = new EventEmitter();

  projects$: Observable<Project[]>;
  currentTimezone: string;
  
  projectConfigurationSubscription: Subscription;

  projectConfiguration: ProjectConfiguration;

  constructor(
    @Inject('ProjectService') private projectService: any,
    private projectConfigurationBehaviorSubjectService: ProjectConfigurationBehaviorSubjectService,
    @Inject('ConfigurationStoreService') private configurationStoreService: any,
    public $state: StateService,
    private projectDataService: ProjectDataService,
    private userProfileService: UserProfileService
  ) {
    this.projectConfigurationSubscription = this.projectConfigurationBehaviorSubjectService.changeOccured.subscribe(() => {
      this.projectConfiguration = this.configurationStoreService.getProjectConfiguration(this.projectId);
    })
    this.projects$ = this.projectDataService.getAllProjects().pipe(
      map(projects => projects.filter(project => project.id > 0)));
  
   }

  ngOnInit(): void {
    this.projectId = this.projectService.getSelectedProjectId();
    this.activePages = this.currentUser && this.projectId >= 0 ? (this.currentUser.projectPageSet ? this.currentUser.projectPageSet[this.projectId] : []) : [];
    this.currentTimezone = this.userProfileService.getProfile('nomad.noc.ng.timezone');
  }

  goToHome = () => {
    this.$state.go('/')
  }

  onMenuClick = (menuItem: AppMenu ) => {
    const data: {projectId?: number} = {};
    if (menuItem && menuItem.page) {
      const page = this.$state.get(menuItem.page);
      if (page && page.url && page.url.indexOf(":projectId") !== -1) {
        data.projectId = this.projectService.getSelectedProjectId();
      }
      this.$state.go(menuItem.page, data, {
        inherit: false,
        reload: true
     });
    }
  }

  onTimezoneChanged = (newTimeZone: string) => {
    this.currentTimezone = newTimeZone;
  }

  onLogout = () => {
    this.logout.emit();
  } 

}
